import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { createStyles, lighten, makeStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import { usePedidos } from '../../../../contexts/Pedidos';
import { ItemEdicaoNovoPedido, ItemResumoPrePedido } from '../../interfaces';
import { PaginationTable } from '../../../../themes/components/PaginationTable';
import { IoMdAddCircle } from 'react-icons/io';
import { TextOnlyTooltip } from '../../../../themes/components/TextOnlyTooltip';
import { Button } from '../../../../themes/components/Button';
import { ImScissors } from 'react-icons/im';
import { useEffectOnce } from 'react-use';
import { useHistory } from 'react-router-dom';
import { useModals } from '../../../../contexts/Modals';
import { useLocalStorage } from '../../../../contexts/LocalStorage';
import { converterStringValorEmFloat, formatarStringQuantidade, mascaraValorEmReal, mascaraValorEmDolar } from '../../../../util/fieldMasks';
import { VscArrowSmallDown, VscArrowSmallUp } from "react-icons/vsc";
import $ from 'jquery';

//Interfaces =======================================================================================================
interface EnhancedTableToolbarProps {
  numSelected: number;
  deletarItensSelecionados: () => void;
  itensNaoEnviadosERP: boolean
}
interface tableProps {
  allowSelectitem: boolean,
  setShowModalAddItens: React.Dispatch<React.SetStateAction<boolean>>,
  selected: string[],
  setSelected: React.Dispatch<React.SetStateAction<string[]>>,
  setValue: React.Dispatch<React.SetStateAction<number>>,
  value: number,
  setItensNaoEnviadosERP: React.Dispatch<React.SetStateAction<boolean>>,
  itensNaoEnviadosERP: boolean,
  idItemErro: string,
  setIdItemErro: React.Dispatch<React.SetStateAction<string>>,
  statusPedidoEnviadoERP: boolean
}

//Estilos  =======================================================================================================

const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
    },
    highlight:
      theme.palette.type === 'light'
        ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
        : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
    title: {
      flex: '1 1 100%',
    },
  }),
);


//Funções Gerais =======================================================================================================

// Tabela de itens ==================================================================================================
export function TabelaListaItens(props: tableProps) {
  const history = useHistory();
  const { getFromSessionStorage } = useLocalStorage();
  const { setShowModalInfo, setShowModalProgress, mostrarInfoOK, mostrarModalProgress } = useModals();
  const { itensDigitacaoPedido, setItensDigitacaoPedido, idPrePedido, atualizaSaldoPrePedido, getPrePedido } = usePedidos();
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [tempPrice, setTempPrice] = useState("");
  const [tempPriceDol, setTempPriceDol] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [valueX, setValueX] = useState(0);


  const [itensPage, setItensPage] = useState<ItemEdicaoNovoPedido[]>([]);
  const [orderBy, setOrderBy] = useState<keyof ItemEdicaoNovoPedido>('codder');
  const [revertOrderBy, setReveterOrderBy] = useState(true);
  const [ordenedItens, setOrdenedItens] = useState<ItemEdicaoNovoPedido[]>([]);

  const cotDolar = ((getFromSessionStorage("cotDol") ? getFromSessionStorage("cotDol")?.toString() : "0"));


  //atualizando itens caso o pré-pedido já tenha sido gerado
  useEffectOnce(() => {
    async function processar(id: number) {
      atualizaSaldoPrePedido(id, history)
        .then((res: any) => {
          if (res.disponibilidade !== undefined) {
            getPrePedido(id, history)
              .then((result: any) => {
                let tempItensDigitacao: ItemEdicaoNovoPedido[] = [];
                let itensEditaveis: boolean = false;
                result[0].produtos.forEach((element: ItemResumoPrePedido) => {
                  //console.log("atualizando saldo");
                  //console.log(element.preco_unitario.toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                  let saldoImediado
                  let saldoProgramado
                  if (element.numero_container === "999") {
                    saldoImediado = element.quantidade_disp;
                    saldoProgramado = 0;
                  } else {
                    saldoImediado = 0;
                    saldoProgramado = element.quantidade_disp;
                  }
                  if (element.sit_item_prepedido === "1") {
                    itensEditaveis = true;
                  }
                  let corte = element.quantidade_corte === 0 ? "vazio" : element.quantidade_corte
                  let dataItem = new Date(String(element.previsao_container));
                  let previsaoContainer = String((dataItem.getUTCDate() < 10 ? '0' : '') + dataItem.getUTCDate() + "/" + ((dataItem.getUTCMonth() + 1 < 10 ? '0' : '') + String(dataItem.getUTCMonth() + 1)) + "/" + dataItem.getUTCFullYear())


                  tempItensDigitacao.push({
                    codclc: element.cod_agrupamento,
                    codctn: element.numero_container,
                    codemp: element.cod_empresa,
                    codder: element.cod_derivacao,
                    codpro: element.cod_produto,
                    desder: element.desc_derivacao,
                    precrt: "",
                    pretab: String(element.preco_tabela),
                    precoVenda: element.preco_unitario.toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    precoVendaUSD: "",
                    salime: String(saldoImediado),
                    salpro: String(saldoProgramado),
                    quantidade: String(element.quantidade),
                    valor: 0,
                    valortotal: element.valor,
                    nomeproduto: element.desc_produto,
                    quantidadecorte: corte,
                    situacaoItem: element.sit_item_prepedido,
                    datprv: previsaoContainer,
                    pedido_erp: element.pedido_erp,
                    qtdpcs: element.tamanho_peca ? element.tamanho_peca : "0",
                    tolmai: element.tolerancia_maior ? element.tolerancia_maior : "900",
                    tolmen: element.tolerancia_menor ? element.tolerancia_menor : "100"
                  });
                });
                if (itensEditaveis === false) {
                  props.setItensNaoEnviadosERP(false);
                }
                setItensDigitacaoPedido(tempItensDigitacao);
                setShowModalProgress(false);
                mostrarInfoOK("Itens carregados!", "Seu número de pré-pedido é " + idPrePedido);
              })
              .catch((error: any) => {
                setShowModalProgress(false);
                console.log(error);
              })
            /*
            if (res.disponibilidade === true) {
              console.log("Disponibilidade dos itens OK");
            } else {
              setShowModalProgress(false);
              mostrarInfoOK(res.message)
            }
            */
          } else {
            setShowModalProgress(false);
            mostrarInfoOK("Falha atualizar saldo dos itens!", "Tente novamente!")
          }
        })
        .catch((err: any) => {
          setShowModalProgress(false);
          console.log(err);
        })
        .finally(() => {
          setShowModalProgress(false);
          setShowModalInfo(false);
        })
    }

    if (idPrePedido) {
      //Carregando informações nos campos
      mostrarModalProgress("Carregando informações dos itens");
      processar(idPrePedido);
    }
  })

  //Componente do título da tabela ===============================================================================
  const EnhancedTableToolbar = (propsChild: EnhancedTableToolbarProps) => {
    const classes = useToolbarStyles();
    const { numSelected } = propsChild;

    return (
      <Toolbar
        className={clsx(classes.root, {
          [classes.highlight]: numSelected > 0,
        })}
      >
        {numSelected > 0 ? (
          <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
            {numSelected} {numSelected === 1 ? "Selecionado" : "Selecionados"}
          </Typography>
        ) : (
          <Typography className={classes.title} variant="h6" id="tableTitle" component="div">

          </Typography>
        )}
        {numSelected > 0 ? (
          <TextOnlyTooltip title="Deletar">
            <IconButton aria-label="Deletar" onClick={() => deletarItensSelecionados()}>
              <DeleteIcon />
            </IconButton>
          </TextOnlyTooltip>
        ) : (
          <>
            {props.itensNaoEnviadosERP === true ?
              <Button onClick={() => props.setShowModalAddItens(true)} classBtn={"btn-footer-novo-pedido color-default"}>
                <div style={{ whiteSpace: 'nowrap' }}>Adicionar Itens <IoMdAddCircle size={30} color={"white"} style={{ marginLeft: '0.5em' }} /></div>
              </Button>
              :
              <></>
            }
          </>
        )}
      </Toolbar>
    );
  };


  // Funções da tabela ====================================================================================================
  function deletarItensSelecionados() {
    let tempListaItens = [...itensDigitacaoPedido];
    let tempSelected = props.selected;
    let newSelected: string[] = [];
    for (let cont = 0; cont < tempSelected.length; cont++) {
      let option = tempSelected[cont];
      for (let index = 0; index < tempListaItens.length; index++) {
        const item = tempListaItens[index];
        // Se o item deve ser removido entra nesse if
        if (option === item.codder + item.codpro + item.codctn) {
          tempListaItens.splice(index, 1);
          break;
        }
        // O item não foi encontrado na lista deve ser mantido.
        //Na teoria, não deve nunca chegar nesse ponto, caso 
        if (index === tempListaItens.length - 1) {
          newSelected.push(option);
        }
      }
    }
    setItensDigitacaoPedido(tempListaItens);
    props.setSelected(newSelected);
    props.setValue(props.value + 1);
  }

  const handleClick = (event: string, elemento: string) => {
    const selectedIndex = props.selected.indexOf(elemento);
    let newSelected: string[] = [];
    let temp = props.selected;

    if (event === "adicionar") {
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(props.selected, elemento);
      } else {
        newSelected = temp;
      }
    } else if (event === "remover") {
      if (selectedIndex >= 0) {
        temp.splice(selectedIndex, 1);
      }
      newSelected = temp;
    } else if (selectedIndex === -1) {
      newSelected = newSelected.concat(props.selected, elemento);
    } else {
      temp.splice(selectedIndex, 1);
      newSelected = temp;
    }
    props.setSelected(newSelected);
    setValueX(valueX + 1);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage - 1);
  };

  const handleSetPage = (newPage: number) => {
    setPage(newPage);
  };

  const handleSetPagePagination = (newPage: number) => {
    setPage(newPage - 1);
  };

  const handleChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDense(event.target.checked);
  };

  const isSelected = (name: string) => props.selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, itensDigitacaoPedido.length - page * rowsPerPage);

  function handlePreco(event: any, id: string) {
    let tempTable = itensDigitacaoPedido;
    let total;
    let index = -1;
    for (let cont = 0; index < tempTable.length; cont++) {
      const element = tempTable[cont];
      if (element.codder + element.codpro + element.codctn === id) {
        index = cont;
        break;
      }
    }
    if (index >= 0) {
      if (event.target.value === "") {
        tempTable[index].precoVenda = "";
        tempTable[index].valortotal = 0
      } else {
        tempTable[index].precoVenda = converterStringValorEmFloat(event.target.value);
        total = parseFloat(tempTable[index].quantidade) * parseFloat(tempTable[index].precoVenda);
        tempTable[index].valortotal = total;
        if (props.idItemErro !== "" && tempTable[index].codder + tempTable[index].codpro + tempTable[index].codctn === props.idItemErro) {
          props.setIdItemErro("");
        }
      }
      setItensDigitacaoPedido(tempTable);
      props.setValue(props.value + 1);
    } else {
      console.error("Falha ao setar o preço no item");
    }
  }

  function handlePrecoDolar(event: any, id: string) {
    let tempTable = itensDigitacaoPedido;
    let total;
    let cotacaoDolar: string | number | null = getFromSessionStorage("cotDol");
    let cotacaoDolarConv = 0
    if (cotacaoDolar !== null) {
      cotacaoDolarConv = parseFloat(cotacaoDolar);
    }
    let index = -1;
    for (let cont = 0; index < tempTable.length; cont++) {
      const element = tempTable[cont];
      if (element.codder + element.codpro + element.codctn === id) {
        index = cont;
        break;
      }
    }
    if (index >= 0) {
      if (event.target.value === "") {
        tempTable[index].precoVendaUSD = "";
        tempTable[index].valortotal = 0;
      } else {
        tempTable[index].precoVendaUSD = converterStringValorEmFloat(event.target.value);
        if (cotacaoDolarConv > 0) {
          let valorDolarxCotacao = parseFloat(tempTable[index].precoVendaUSD) * cotacaoDolarConv;
          total = parseFloat(tempTable[index].quantidade) * valorDolarxCotacao;
          tempTable[index].precoVenda = (valorDolarxCotacao).toFixed(2);
        } else {
          total = parseFloat(tempTable[index].quantidade) * parseFloat(tempTable[index].precoVendaUSD)
        }
        tempTable[index].valortotal = total;
        if (props.idItemErro !== "" && tempTable[index].codder + tempTable[index].codpro + tempTable[index].codctn === props.idItemErro) {
          props.setIdItemErro("");
        }
      }
      setItensDigitacaoPedido(tempTable);
      props.setValue(props.value + 1);
    } else {
      console.error("Falha ao setar o preço em dólar no item");
    }
  }

  function handleClickPreco(id: string) {
    let tempTable = itensDigitacaoPedido;
    let index = -1;
    for (let cont = 0; index < tempTable.length; cont++) {
      const element = tempTable[cont];
      if (element.codder + element.codpro + element.codctn === id) {
        index = cont;
        break;
      }
    }
    if (index >= 0) {
      setTempPrice(tempTable[index].precoVenda ? tempTable[index].precoVenda : tempTable[index].pretab);
      tempTable[index].precoVenda = "";
      tempTable[index].valortotal = 0;
      setItensDigitacaoPedido(tempTable);
      props.setValue(props.value + 1);
    } else {
      console.error("Falha ao clicar e limpar o preço");
    }
  }

  function onBlurFieldPrice(id: string) {
    let tempTable = itensDigitacaoPedido;
    let index = -1;
    for (let cont = 0; index < tempTable.length; cont++) {
      const element = tempTable[cont];
      if (element.codder + element.codpro + element.codctn === id) {
        index = cont;
        break;
      }
    }

    if (index >= 0) {
      if (!tempTable[index].precoVenda) {
        if (tempPrice) {
          tempTable[index].precoVenda = tempPrice;
          tempTable[index].valortotal = parseFloat(tempTable[index].quantidade) * parseFloat(tempPrice);
        }
      }
      if (!tempTable[index].precoVendaUSD) {
        if (tempPriceDol) {
          tempTable[index].precoVenda = tempPrice;
          tempTable[index].precoVendaUSD = tempPriceDol;
          tempTable[index].valortotal = parseFloat(tempTable[index].quantidade) * parseFloat(tempPrice);
        }
      }
      setItensDigitacaoPedido(tempTable);
      props.setValue(props.value + 1);
    } else {
      console.error("Falha ao volltar preço anterior");
    }
  }

  function handleClickPrecoDolar(id: string) {
    let tempTable = itensDigitacaoPedido;
    let index = -1;
    for (let cont = 0; index < tempTable.length; cont++) {
      const element = tempTable[cont];
      if (element.codder + element.codpro + element.codctn === id) {
        index = cont;
        break;
      }
    }
    if (index >= 0) {
      if (tempTable[index].codctn != "999") {
        const precoBr = (tempTable[index].precoVenda ? tempTable[index].precoVenda : tempTable[index].pretab).replace(",", ".");
        const precoDolar = (parseFloat(precoBr ? precoBr : "0") / parseFloat(cotDolar ? cotDolar : "0")).toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setTempPriceDol(precoDolar.replace(",", "."));
        setTempPrice((parseFloat(precoDolar.replace(",", ".")) * parseFloat(cotDolar ? cotDolar : "0")).toString());
        //alert(tempPrice);
        tempTable[index].precoVendaUSD = "";
        tempTable[index].valortotal = 0;
        setItensDigitacaoPedido(tempTable);
        props.setValue(props.value + 1);
      }
    } else {
      console.error("Falha ao clicar e limpar o preço dólar");
    }
  }

  function getFocusCorte(id: string) {
    $(function () {
      (document.getElementById(id) as HTMLInputElement)?.focus({ preventScroll: false });
    })
  }

  function handleCorte(event: any, index: number) {
    let tempTable = itensDigitacaoPedido;
    if (event.target.value !== "") {
      tempTable[index].quantidadecorte = parseInt(event.target.value)
    } else {
      tempTable[index].quantidadecorte = "vazio"
    }
    //Limpando marcação de erro caso o item tivesse 
    if (props.idItemErro !== "" && tempTable[index].codder + tempTable[index].codpro + tempTable[index].codctn === props.idItemErro) {
      props.setIdItemErro("");
    }
    setItensDigitacaoPedido(tempTable);
    props.setValue(props.value + 1);
  }

  function handleQuantidade(event: any, id: string) {
    let tempTable = itensDigitacaoPedido;
    let total;
    let index = -1;
    for (let cont = 0; cont < tempTable.length; cont++) {
      const element = tempTable[cont];
      if (element.codder + element.codpro + element.codctn === id) {
        index = cont;
        break;
      }
    }
    if (index >= 0) {
      if (event.target.value === "") {
        tempTable[index].quantidade = "";
        total = 0
        tempTable[index].valortotal = 0
        handleClick("adicionar", tempTable[index].codder + tempTable[index].codpro + tempTable[index].codctn);
      } else {
        let value = formatarStringQuantidade(event.target.value);
        tempTable[index].quantidade = value;
        if (tempTable[index].precoVenda !== undefined) {
          if (tempTable[index].precoVenda !== "") {

            if (getFromSessionStorage("pedDol") === "S" && tempTable[index].codctn != "999") {
              const precoBr = tempTable[index].precoVenda.replace(",", ".");
              const precoDolar = (parseFloat(precoBr ? precoBr : "0") / parseFloat(cotDolar ? cotDolar : "0")).toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
              let real = parseFloat(precoDolar.replace(",", ".")) * parseFloat(cotDolar ? cotDolar : "0");
              total = (parseFloat(tempTable[index].quantidade) * real);

            } else {
              total = parseFloat(tempTable[index].quantidade) * parseFloat(tempTable[index].precoVenda.replace(",", "."));
            }

          } else {
            tempTable[index].precoVenda = parseFloat(tempTable[index].pretab).toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });

            if (getFromSessionStorage("pedDol") === "S" && tempTable[index].codctn != "999") {
              const precoBr = tempTable[index].precoVenda.replace(",", ".");
              const precoDolar = (parseFloat(precoBr ? precoBr : "0") / parseFloat(cotDolar ? cotDolar : "0")).toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
              let real = parseFloat(precoDolar.replace(",", ".")) * parseFloat(cotDolar ? cotDolar : "0");
              total = (parseFloat(tempTable[index].quantidade) * real);

            } else {
              total = parseFloat(tempTable[index].quantidade) * parseFloat(tempTable[index].pretab.replace(",", "."));
            }

          }
        } else {

          if (getFromSessionStorage("pedDol") === "S" && tempTable[index].codctn != "999") {
            const precoBr = tempTable[index].precoVenda.replace(",", ".");
            const precoDolar = (parseFloat(precoBr ? precoBr : "0") / parseFloat(cotDolar ? cotDolar : "0")).toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
            let real = parseFloat(precoDolar.replace(",", ".")) * parseFloat(cotDolar ? cotDolar : "0");
            total = (parseFloat(tempTable[index].quantidade) * real);

          } else {
            total = parseFloat(tempTable[index].quantidade) * parseFloat(tempTable[index].pretab.replace(",", "."));
          }
        }
        tempTable[index].valortotal = total
        handleClick("remover", tempTable[index].codder + tempTable[index].codpro + tempTable[index].codctn);

        //validando quantidade x saldo
        if (parseFloat(tempTable[index].salpro) + parseFloat(tempTable[index].salime) < parseFloat(value)) {
          props.setIdItemErro(tempTable[index].codder + tempTable[index].codpro + tempTable[index].codctn);
        }
      }
      if (props.idItemErro !== "" && tempTable[index].codder + tempTable[index].codpro + tempTable[index].codctn === props.idItemErro) {
        props.setIdItemErro("");
      }
      setItensDigitacaoPedido(tempTable);
      props.setValue(props.value + 1);
    }
  }


  //Define a seta de ordenação que vai aparecer o lado do nome da coluna
  function showOrderByIcon(option: string) {
    if (orderBy === option) {
      if (revertOrderBy) {
        return <VscArrowSmallDown size={20} />
      } else {
        return <VscArrowSmallUp size={20} />
      }
    } else {
      return <></>
    }
  }

  // This effect apply the filtered caracters on products and set an array only with matched results
  // Whenever have change in filtered the current page is set to 0, the initial page 
  useEffect(() => {
    if (ordenedItens instanceof Array) {
      let tempItens = [...ordenedItens];

      if (revertOrderBy) {
        tempItens.sort(function (a, b) {
          let keyA = parseInt((a as any)[orderBy]), keyB = parseInt((b as any)[orderBy]);
          // Compare the 2 dates
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });
      } else {
        tempItens.sort(function (a, b) {
          let keyA = parseInt((a as any)[orderBy]), keyB = parseInt((b as any)[orderBy]);
          // Compare the 2 dates
          if (keyA > keyB) return -1;
          if (keyA < keyB) return 1;
          return 0;
        });
      }
      handleSetPage(0);
      setOrdenedItens(tempItens);
    }
  }, [orderBy, revertOrderBy]);


  useEffect(() => {
    setOrdenedItens(itensDigitacaoPedido instanceof Array ? itensDigitacaoPedido : [itensDigitacaoPedido]);
  }, [itensDigitacaoPedido]);

  // This effect push the filtered registers in current page
  useEffect(() => {
    let tempItens = [];
    let maxReg = (page + 1) * rowsPerPage;
    for (let index = page * rowsPerPage; index < maxReg && index < ordenedItens.length; index++) {
      if (getFromSessionStorage("pedDol") === "S") {
        if (!ordenedItens[index].precoVendaUSD) {
          if (ordenedItens[index].codctn != "999") {
            const precoBr = ordenedItens[index].precoVenda.replace(",", ".");
            const precoDolar = (parseFloat(precoBr ? precoBr : "0") / parseFloat(cotDolar ? cotDolar : "0")).toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
            ordenedItens[index].precoVendaUSD = precoDolar;

          }
        }
      }
      if (ordenedItens[index] !== undefined)
        //console.log(ordenedItens[index]);
      tempItens.push(ordenedItens[index]);
    }
    setItensPage(tempItens);
  }, [ordenedItens, page, rowsPerPage, orderBy, revertOrderBy]);

  return (
    <div className="tabela-itens-pedido-novo">
      <div>
        {props.allowSelectitem &&
          <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '1em' }}>
            <TextOnlyTooltip title="Densidade da tabela" placement="top">
              <FormControlLabel
                control={<Switch checked={dense} onChange={handleChangeDense} />}
                label=""
              />
            </TextOnlyTooltip>
            <EnhancedTableToolbar numSelected={props.selected.length} deletarItensSelecionados={deletarItensSelecionados} itensNaoEnviadosERP={props.itensNaoEnviadosERP} />
          </div>
        }
      </div>
      <div className="tabela-paginacao-area">
        <TableContainer component={Paper} className={"root-tabela-lista-pedidos"}>
          <Table
            stickyHeader
            aria-label="collapsible table"
            size={dense ? 'small' : 'medium'}>
            <TableHead>
              <TableRow>
                <TableCell>{props.statusPedidoEnviadoERP === true || props.itensNaoEnviadosERP === false ? "Pedido" : ""}</TableCell>
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("codclc") }}>{showOrderByIcon("codclc")}Agrupamento</TableCell>
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("codctn") }} align="left">{showOrderByIcon("codctn")}Container</TableCell>
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("codemp") }} align="left">{showOrderByIcon("codemp")}Empresa</TableCell>
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("codder") }} align="center">{showOrderByIcon("codder")}Derivação</TableCell>
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("codpro") }} align="center">{showOrderByIcon("codpro")}Produto</TableCell>
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("salime") }} align="right">{showOrderByIcon("salime")}Saldo Imediato</TableCell>
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("salpro") }} align="right">{showOrderByIcon("salpro")}Saldo Programado</TableCell>
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("valor") }} align="right">{showOrderByIcon("valor")}Valor Unitário (R$)</TableCell>
                {getFromSessionStorage("pedDol") === "S" && <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("precoVendaUSD") }} align="right">{showOrderByIcon("precoVendaUSD")}Valor Unitário (U$)</TableCell>}
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("quantidade") }} align="right">{showOrderByIcon("quantidade")}Quantidade</TableCell>
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("quantidadecorte") }} align="right">{showOrderByIcon("quantidadecorte")}Corte</TableCell>
                <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("valortotal") }} align="right">{showOrderByIcon("valortotal")}Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {itensPage !== null && itensPage instanceof Array && itensPage.length > 0 ?
                itensPage.map((row, index) => {
                  const isItemSelected = isSelected(row.codder + row.codpro + row.codctn);

                  //console.log(row);

                  const labelId = `enhanced-table-checkbox-${index}`;
                  let totalResult: string = "";
                  let atualQtd: string = "";
                  let precoUnit: string = "";
                  let precoUnitDolar: string = "";
                  if (row.precoVenda === undefined) {
                    precoUnit = parseFloat(row.pretab).toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
                  } else if (row.precoVenda === "") {
                    precoUnit = ""
                  } else {
                    precoUnit = parseFloat(row.precoVenda.replace(",", ".")).toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
                  }

                  if (getFromSessionStorage("pedDol") === "S") {
                    if (!row.precoVendaUSD) {
                       precoUnitDolar = "";
                                           
                    } else {
                      precoUnitDolar = mascaraValorEmDolar(row.precoVendaUSD).toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      precoUnit = (parseFloat(precoUnitDolar.replace(",",".")) * parseFloat(cotDolar?cotDolar:"0")).toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
                     //console.log(`cotacao: ${cotDolar} / Valor do produto em dolar: ${precoUnitDolar}`);
                    }

                  }

                  /*if (getFromSessionStorage("pedDol") === "S") {
                    if (row.precoVendaUSD === undefined) {
                      precoUnitDolar = ""
                    } else if (row.precoVendaUSD === "") {
                      precoUnitDolar = ""
                    } else {
                      precoUnitDolar = mascaraValorEmDolar(row.precoVendaUSD);
                    }
                  }*/

                  if (row.quantidade !== undefined && row.quantidade !== "") {
                    totalResult = row.valortotal.toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });;
                    atualQtd = row.quantidade.replace(".", ",");
                  } else {
                    totalResult = "";
                    atualQtd = "";
                  }

                  function disableFieldPriceDolar() {
                    return getFromSessionStorage("pedDol") !== "S" || row.codctn === "999" ? true : false;
                  }
                  function disableFieldPrice() {
                    return getFromSessionStorage("pedDol") === "S" && row.codctn !== "999" ? true : false;
                  }

                  function getInfoCorte(id: string) {
                    let tempTable = itensDigitacaoPedido;
                    let i = -1;
                    for (let cont = 0; cont < tempTable.length; cont++) {
                      const element = tempTable[cont];
                      if (element !== undefined) {
                        if (element.codder + element.codpro + element.codctn === id) {
                          i = cont;
                          break;
                        }
                      }
                    }
                    if (i >= 0) {
                      if (tempTable[i].quantidadecorte === undefined || tempTable[i].quantidadecorte === "vazio") {
                        return (
                          <Button titleText="Tamanho de corte" disabled={row.situacaoItem === "2" ? true : false} classBtn={'btn-cut-add-item'} onClick={() => [handleCorte({ target: { value: 0 } }, i), getFocusCorte(`cut-${row.codder}${row.codpro}${row.codctn}`)]}>
                            <ImScissors />
                          </Button>
                        )

                      } else {
                        return <input disabled={row.situacaoItem === "2" ? true : false} type="text" onChange={(event: any) => handleCorte(event, i)} value={row.quantidadecorte !== 0 ? row.quantidadecorte : ""} style={{ textAlign: 'right', border: '1px solid #ccc', borderRadius: '5px', width: '60%' }} />
                      }
                    }
                  }

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.codder + row.codpro + row.codctn}
                      selected={isItemSelected}
                      className={row.situacaoItem === "2" ? "linha-pedido-enviado" : props.idItemErro === row.codder + row.codpro + row.codctn ? "additem-linha-error" : isItemSelected ? row.codemp == "2" ? "additem-linha-selecionada" : "additem-linha-selecionada1" : "additem-linha-padrao-" + row.codemp}
                    >
                      {props.allowSelectitem ?
                        <>
                          {row.situacaoItem !== "2" ?
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ 'aria-labelledby': labelId }}
                                color={'primary'}
                                onClick={(event) => handleClick("checkbox", row.codder + row.codpro + row.codctn)}
                              />
                            </TableCell>
                            :
                            <TableCell padding="checkbox">
                              {row.pedido_erp !== undefined ? row.pedido_erp : ""}
                            </TableCell>
                          }
                        </>
                        :
                        <></>
                      }
                      <TableCell
                        id={labelId}
                        scope="row"
                        align="left"
                      >
                        {row.codclc}
                      </TableCell>
                      <TableCell align="left">{row.codctn}</TableCell>
                      <TableCell align="left">{row.codemp == "2" ? "GA" : row.codemp == "4" ? "AB" : row.codemp}</TableCell>
                      <TableCell align="left">{row.codder + " - " + row.desder}</TableCell>
                      <TableCell align="left">{row.codpro}</TableCell>
                      <TableCell align="right">{parseFloat(row.salime).toLocaleString('pt-br', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                      <TableCell align="right">{parseFloat(row.salpro).toLocaleString('pt-br', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                      <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>R$ <input disabled={(row.situacaoItem === "2" ? true : false) || disableFieldPrice()} type="text" onClick={() => handleClickPreco(row.codder + row.codpro + row.codctn)} onChange={(event: any) => handlePreco(event, row.codder + row.codpro + row.codctn)} onBlur={() => onBlurFieldPrice(row.codder + row.codpro + row.codctn)} value={precoUnit} style={{ textAlign: 'right', border: '1px solid #ccc', borderRadius: '5px', width: '60%' }} /></TableCell>
                      {getFromSessionStorage("pedDol") === "S" && <TableCell align="right"><input type="text" onClick={() => handleClickPrecoDolar(row.codder + row.codpro + row.codctn)} onChange={(event: any) => handlePrecoDolar(event, row.codder + row.codpro + row.codctn)} onBlur={() => onBlurFieldPrice(row.codder + row.codpro + row.codctn)} value={precoUnitDolar} style={{ textAlign: 'right', border: '1px solid #ccc', borderRadius: '5px', width: '60%' }} disabled={disableFieldPriceDolar()} /></TableCell>}
                      <TableCell align="right"><input disabled={row.situacaoItem === "2" ? true : false} type="text" onChange={(event: any) => handleQuantidade(event, row.codder + row.codpro + row.codctn)} value={atualQtd} style={{ textAlign: 'right', border: '1px solid #ccc', borderRadius: '5px', width: '70%' }} /></TableCell>
                      <TableCell align="right">{getInfoCorte(row.codder + row.codpro + row.codctn)}</TableCell>
                      <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>R$ <input disabled value={totalResult} style={{ textAlign: 'right', border: '1px solid #ccc', borderRadius: '5px', width: '80%' }} /></TableCell>
                    </TableRow>
                  );
                })
                :
                <></>
              }
              {emptyRows > 0 && Math.ceil(itensDigitacaoPedido.length / rowsPerPage) > 1 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }} >
                  <TableCell colSpan={10} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <PaginationTable
          textSingle="Item"
          textPlural="Itens"
          arrayItens={itensDigitacaoPedido}
          page={page + 1}
          countPages={Math.ceil(itensDigitacaoPedido.length / rowsPerPage)}
          defaultPage={0}
          handleChange={handleChangePage}
          shape="round"
          styleCLasses={"padding-right"}
          setCurrentPage={handleSetPagePagination}
          setPerPage={setRowsPerPage}
          optionsPerPage={[5, 10, 50]}
          perPage={rowsPerPage}
        />
      </div>
    </div>
  );
}